import styled from 'styled-components';

export const InformationContainerStyled = styled.div`
  .filter_layout {
    margin-bottom: 1rem;
  }
`;
